export const AccompConfig = {
  items: [
    {
      institution: "WealthTech",
      logo: "wealthtech.png",
      link:
        "http://fintech.global/globalwealthtechsummit/wp-content/uploads/2019/04/WealthTech_100_summary_2019.pdf"
    },
    {
      institution: "WebSummit",
      logo: "websummit.png",
      link: "https://www.youtube.com/watch?v=ONcsABwIQe0&t=1s"
    },
    {
      institution: "Metlife",
      logo: "MetLife.png",
      link:
        "http://www.economiaengalicia.com/articulo/empresa/startup-gallega-opseeker-gana-competicion-innovacion-financiera-metlife-foundation/20180710130316007682.html"
    },
    {
      institution: "Everis",
      logo: "everis.png",
      link: "https://fundacioneveris.com/en/node/102"
    },
    {
      institution: "PEL",
      date: "Feb 2018",
      logo: "PEL.png",
      link:
        "https://www.lavozdegalicia.es/noticia/coruna/2018/03/24/porto-muinos-dinahosting-opseeker-tech-premios-pel-diputacion/0003_201803H24C8991.htm"
    },
    {
      institution: "BusinessInsider",
      date: "Feb 2018",
      logo: "businessInsider.png",
      link:
        "https://www.businessinsider.es/15-startups-empresas-innovadoras-espanolas-seguir-2018-183292"
    },
    {
      institution: "YuzzNational",
      date: "Nov 2017",
      logo: "santander.png",
      link:
        "https://www.lavozdegalicia.es/noticia/santiago/santiago/2017/11/07/web-gestionar-dinero-creada-usc-gano-tercer-premio-yuzz/0003_201711S7C4993.htm"
    },
    {
      institution: "BBVA",
      date: "May 2017",
      text:
        "We participate in the South Summit as part of the Abanca invested companies.",
      logo: "bbva.svg",
      link:
        "https://www.farodevigo.es/economia/2017/05/11/viguesa-senseitrade-impone-competicion-startups/1676819.html"
    }
  ]
};

export default AccompConfig;



// WEBPACK FOOTER //
// ./src/containers/accomplishments/AccompConfig.js